import { IllustrationsBox } from '@ahmdigital/ui';
import classNames from 'classnames';

import { SalesIllustrationsProps } from './types';
import device from '../../../../../../../utils/device';
import IllustrationContent from './illustration-content';
import styles from './styles.module.sass';
import useViewportValue from '../../../../../../../utils/use-viewport-value';

const SalesIllustrations = ({
  className,
  leftImage,
  rightImage,
  options,
  pricingInfo,
  title,
  productId,
  ...props
}: SalesIllustrationsProps) => {
  const isMobile = useViewportValue(device.isTabletOrMobile);

  const getResponsiveSrc = (image: { src: string; mobileSrc?: string }) =>
    isMobile && image.mobileSrc ? image.mobileSrc : image.src;

  return (
    <div className={styles.illustrationContainer}>
      <IllustrationsBox
        {...props}
        className={classNames(styles.wrapper, className)}
        leftImage={
          leftImage && {
            alt: leftImage.alt,
            className: classNames(styles.leftImage, leftImage.className),
            src: getResponsiveSrc(leftImage),
          }
        }
        rightImage={
          rightImage && {
            alt: rightImage.alt,
            className: classNames(styles.rightImage, rightImage.className),
            src: getResponsiveSrc(rightImage),
          }
        }
      >
        <IllustrationContent title={title} options={options} productId={productId} />
      </IllustrationsBox>
    </div>
  );
};

export default SalesIllustrations;
